<script setup lang="ts">

import { faPlus } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppIcon } from '@shared/ui/icons'
import { BtnSecondary } from '@shared/ui/buttons'

import DisciplineWeeklyScheduleActions from './DisciplineWeeklyScheduleActions.vue'
import DisciplineBalanceCard from './DisciplineBalanceCard.vue'
import { useDisciplineWeeklySchedule } from '../model/discipline-weekly-schedule.hook'

defineOptions({
  name: 'DisciplineWeeklySchedule',
})

const {
  refPaceText,
  refDays,
  refHasSchedule,
  refStartDate,
  refIsCreateDisabled,
  openCreate,
} = useDisciplineWeeklySchedule()
</script>

<template>
  <DisciplineBalanceCard
    title="Weekly schedule"
    class="discipline-weekly-schedule"
  >
    <template
      v-if="refPaceText"
      #subtitle
    >
      <AppText
        name="body2"
        color="slate-500"
      >
        {{ refPaceText }}
      </AppText>
    </template>
    <template v-if="refHasSchedule">
      <AppText
        v-for="day in refDays"
        :key="day"
        name="body1"
      >
        {{ day }}
      </AppText>
      <AppText
        v-if="refStartDate"
        name="body2-medium"
        class="discipline-weekly-schedule__start"
      >
        💡 Start date: {{ refStartDate }}
      </AppText>
    </template>
    <BtnSecondary
      v-else
      text="Create"
      color="blue"
      element-width="full"
      class="discipline-weekly-schedule__create"
      :disabled="refIsCreateDisabled"
      @click="openCreate"
    >
      <template #iconLeft>
        <AppIcon :icon="faPlus" />
      </template>
    </BtnSecondary>
    <template #options>
      <DisciplineWeeklyScheduleActions :disabled="!refHasSchedule" />
    </template>
  </DisciplineBalanceCard>
</template>

<style scoped lang="scss" src="./DisciplineWeeklySchedule.scss" />
